import styled from "styled-components/macro";

export const WrapperContainer = styled.div`
  & > .header {
    margin-bottom: 16px;

    & > div {
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      margin-left: auto;
      align-items: center;
      & > div {
        align-self: flex-start;
      }
    }
  }
  & .min-width {
    min-width: 60px;
  }

  & > .mainContent {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    @media ${(props) => props.theme.media.phone} {
      flex-direction: column;
    }

    & * > p {
      font-size: 1rem;
      line-height: 130%;
      margin: 0;
      color: ${(props) => props.theme.colors.text};

      &.title {
        font-weight: 600;
      }
    }
  }
`;

export const TogglePublish = styled.div`
  height: 16px;
  width: 100%;
  background-color: #cdc2ba;
  position: relative;
  border-radius: 34px;
  cursor: pointer;
  transition: 0.4s;

  &:before {
    background-color: #fff;
    bottom: 2px;
    content: "";
    height: 12px;
    left: 2px;
    position: absolute;
    transition: 0.4s;
    width: 12px;
    border-radius: 50%;
  }
`;

export const PublishButton = styled.div<{ isRented?: boolean }>`
  @media ${(props) => props.theme.media.phone} {
    margin-top: 1rem;
    width: 100%;
  }
  width: 175px;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${(props) => props.theme.colors.text};
  font-size: ${(props) => props.theme.font.size};
  & > a,
  & > label {
    height: 16px;
    width: 32px;
  }

  & > label {
    display: flex;
    position: relative;

    & > input {
      display: none;
    }
    & > button {
      display: none;
    }

    .slider {
      background-color: #cdc2ba;
      bottom: 0;
      cursor: pointer;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      transition: 0.4s;
    }

    .slider:before {
      background-color: #fff;
      bottom: 2px;
      content: "";
      height: 12px;
      left: 2px;
      position: absolute;
      transition: 0.4s;
      width: 12px;
    }

    input:checked + .slider {
      background-color: ${(props) =>
        props.isRented ? props.theme.colors.place : props.theme.colors.primary};
    }

    input:checked + .slider:before {
      transform: translateX(16px);
    }

    .slider.round {
      border-radius: 34px;
    }

    .slider.round:before {
      border-radius: 50%;
    }
  }

  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.border};
`;

export const GridDeleteRoom = styled.div`
  display: grid;
  width: 100%;
  gap: 16px;
  padding: 16px;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    "titleDel titleDel"
    "textDel textDel"
    "butCancel butDel";
  & > .titleDel {
    grid-area: titleDel;
  }
  & > .textDel {
    grid-area: textDel;
  }
  & > .butCancel {
    grid-area: butCancel;
  }
  & > .butDel {
    grid-area: butDel;
  }
  @media ${(props) => props.theme.media.phone} {
    grid-template-columns: 1fr;
    grid-template-areas:
      "titleDel"
      "textDel"
      "butCancel"
      "butDel";
  }
`;
